import script from "./RadioButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./RadioButtons.vue?vue&type=script&lang=ts&setup=true"

import "./RadioButtons.vue?vue&type=style&index=0&id=ba8ce9c0&lang=scss"

const __exports__ = script;

export default __exports__